import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    StudentCommentService,
    StudentCommentPopupService,
    StudentCommentDetailComponent,
    StudentCommentDialogComponent,
    StudentCommentPopupComponent,
    StudentCommentDeletePopupComponent,
    StudentCommentDeleteDialogComponent,
    StudentCommentRoute,
    StudentCommentPopupRoute,
} from './';

let ENTITY_STATES = [
    ...StudentCommentRoute,
    ...StudentCommentPopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        StudentCommentDetailComponent,
        StudentCommentDialogComponent,
        StudentCommentDeleteDialogComponent,
        StudentCommentPopupComponent,
        StudentCommentDeletePopupComponent,
    ],
    entryComponents: [
        StudentCommentDialogComponent,
        StudentCommentPopupComponent,
        StudentCommentDeleteDialogComponent,
        StudentCommentDeletePopupComponent,
    ],
    providers: [
        StudentCommentService,
        StudentCommentPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiStudentCommentModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student-comment/student-comment.module.ts